import { useEffect, useState, FC } from 'react';
import { useHistory } from 'react-router-dom';

//Components
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import ActivityLoading from '../common/ActivityLoading';
import ActivityToast from '../common/ActivityToast';

//Services
import { getActivityById } from '../../services/ActivityService';

//Types
import { ToastOptionsInterface } from '../common/Types';

const ActivityView: FC = (props: any) => {
    const { location } = props;
    const [loading, setLoading] = useState(false);
    const [activity, setActivity] = useState<any>(undefined);
    const [description, setDescription] = useState("");
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        const locationSplit = location.pathname.split('/');
        getActivityById(locationSplit[3]).then((actResp: any) => {
            setActivity(actResp);
            setLoading(false);
        });
    }, [location]);

    useEffect(() => {
        if (activity) {
            const totalChar = 100;
            if (activity.description.length > totalChar) {
                setDescription(activity.description.substring(0, totalChar - 3) + "...")
            } else if (activity.description.length < totalChar) {
                setDescription(activity.description)
            } else {
                setDescription(activity.description)
            }
        }
    }, [activity]);

    const goBack = () => {
        history.goBack();
    }

    return (
        <Container>
            {
                loading ?
                    <ActivityLoading />
                    :
                    <>
                        <ActivityToast {...toastOptions} onClose={() => setToastOptions({ open: false, message: "" })} autohide={4000} />
                        <div style={{ marginBottom: '20px' }}>
                            <h1>Student View</h1>
                        </div>
                        <Button
                            type="submit"
                            variant="outline-primary"
                            aria-label="save"
                            className="return-button"
                            onClick={() => goBack()}
                            style={{ marginTop: '7px' }}
                        >
                            {`Return`}
                        </Button>
                        {activity ?
                            <Row xs={1} sm={2} md={2} lg={3} className="g-4">
                                <Col>
                                    <Card>
                                        <Card.Img style={{ width: '100%' }} variant="top" src={activity.image_url ? activity.image_url : "../../cccr-default.jpg"} />
                                        <Card.Body>
                                            <Card.Title>{activity.name}</Card.Title>
                                            <Card.Subtitle>{`Registered: ${activity.inscribed}/${activity.students_limit}`}</Card.Subtitle>
                                            <Card.Text style={{ overflow: 'hidden', textOverflow: 'ellipsis', minHeight: '100px', maxHeight: '100px', textAlign: 'justify', marginTop: '10px' }}>
                                                {description}
                                            </Card.Text>
                                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px', alignItems: 'center' }}>
                                                <Button variant="primary" disabled={true} style={{ width: '100%' }} >Suscribe</Button>
                                                <Button variant="primary" disabled={true} style={{ marginLeft: '10px', width: '100%' }}>Details</Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            :
                            null}
                    </>
            }
        </Container>
    )
}

export default ActivityView;
